import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@skbkontur/react-ui';
export const SaveButton = ({ status, isEditPage, ...rest }) => {
    const loading = status === 'saving' || status === 'checking';
    return (_jsx(Button, { use: "primary", size: "medium", type: "submit", loading: loading, ...rest, children: isEditPage ? 'Сохранить' : 'Добавить' }));
};
